module.exports = __webpack_public_path__ + "static/media/proordem-oline-n.bd583faf.svg";